// src/api/leads.ts
import { apiRequest } from "../utils/apiClient"; // adjust path if needed

// CREATE LEAD
export const createLead = async (lead: any) => {
  const response = await apiRequest("/api/leads", "POST", lead);

  if (response.status === 400) {
    alert('Business already exists.');
    return false;
  }
  if (response.status !== 200 && response.status !== 201) {
    throw new Error(response.message || "Failed to create lead");
  }

  return response.data;
};

// UPDATE LEAD
export const updateLead = async (id: number, lead: any) => {
  const response = await apiRequest(`/api/leads/${id}`, "PUT", lead);

  if (response.status !== 200) {
    throw new Error(response.message || "Failed to update lead");
  }

  return response.data;
};

// DELETE LEAD
export const deleteLead = async (id: number) => {
  const response = await apiRequest(`/api/leads/${id}`, "DELETE");

  if (response.status !== 200) {
    throw new Error(response.message || "Failed to delete lead");
  }

  return response.data;
};

// GET LEADS WITH FILTERS
// export const fetchLeads = async (filters?: any) => {
//   const response = await apiRequest("/api/leads", "GET", filters);

//   if (response.status !== 200) {
//     throw new Error(response.message || "Failed to fetch leads");
//   }

//   return response.data;
// };
export const fetchLeads = async (filters?: any) => {
  const response = await apiRequest("/api/leads/list", "POST", filters);

  if (response.status !== 200) {
    throw new Error(response.message || "Failed to fetch leads");
  }

  return response.data;
};

// OPTIONAL: fetch a single lead by id
export const fetchLeadById = async (id: number) => {
  const response = await apiRequest(`/api/leads/${id}`, "GET");

  if (response.status !== 200) {
    throw new Error(response.message || "Failed to fetch lead");
  }

  return response.data;
};